import { Component, computed, input } from '@angular/core';

import type { User } from '@core/account-types';
import type { Attachment } from '@core/attachments-types';
import { AttachmentItemComponent } from '@core/attachments-ui';
import type { AggregatedEvaluationsAttachment } from '@core/evaluations-types';
import { TranslatePipe } from '@core/i18n-legacy';
import { EmptyStateComponent, HeadingComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-candidate-offer-evaluation-question-attachments',
  templateUrl: './candidate-offer-evaluation-question-attachments.component.html',
  styleUrl: './candidate-offer-evaluation-question-attachments.component.less',
  imports: [AttachmentItemComponent, EmptyStateComponent, HeadingComponent, TranslatePipe],
})
export class CandidateOfferEvaluationQuestionAttachmentsComponent {
  public questionTitle = input.required<string | null>();
  public answersCount = input.required<number>();
  public commentsCount = input(0);
  public attachments = input.required<AggregatedEvaluationsAttachment[]>();

  protected items = computed<Attachment[]>(() =>
    this.attachments().map(({ admin, ...attachment }) => ({
      ...attachment,
      admin: <User>(<unknown>{ ...admin, firstName: admin.name, lastName: '' }),
      private: false,
    })),
  );
}
